import { Query } from 'src/types/Request';

export const buildQueryString = (query: Query) => {
    const queryString = Object.entries(query).reduce((str, [key, value]) => {
        return `${str}&${key}=${value}`
    }, '')

    return queryString;
}